import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import { desktopCSS, mobileAndTabletCSS } from '@measures/responsive'
import useClientViewportType from '@hooks/useClientViewportType'

export interface SideFlowWrapperProps {
  hasRelatedItems: boolean
  numberOfNonAdItemsInSideFlow: number
  children: ReactNode
  shouldShowBundling?: boolean
}

export type StyledSideFlowWrapperProps = Pick<
  SideFlowWrapperProps,
  'hasRelatedItems' | 'numberOfNonAdItemsInSideFlow' | 'shouldShowBundling'
>

const StyledSideFlowWrapper = styled.div<StyledSideFlowWrapperProps>`
  ${({
    theme: {
      spacing: { spacing16, spacing24 },
    },
    hasRelatedItems,
    numberOfNonAdItemsInSideFlow,
    shouldShowBundling,
  }) => css`
    ${desktopCSS(css`
      grid-column: span 4;
      display: grid;
      height: 100%;
      grid-template-columns: minmax(0, 1fr);
      grid-template-rows: repeat(${numberOfNonAdItemsInSideFlow}, auto) minmax(
          0,
          1fr
        );
      grid-row-gap: ${hasRelatedItems ? spacing16 : spacing24};
      align-items: flex-start;
      ${shouldShowBundling &&
      css`
        grid-template-rows: auto minmax(0, 1fr);
      `}
    `)}

    ${mobileAndTabletCSS(css`
      display: none;
    `)};
  `}
`

const SideFlowWrapper: FunctionComponent<SideFlowWrapperProps> = ({
  children,
  hasRelatedItems,
  numberOfNonAdItemsInSideFlow,
  shouldShowBundling,
}) =>
  !['server', 'desktop'].includes(useClientViewportType()) ? null : (
    <StyledSideFlowWrapper
      hasRelatedItems={hasRelatedItems}
      numberOfNonAdItemsInSideFlow={numberOfNonAdItemsInSideFlow}
      shouldShowBundling={shouldShowBundling}>
      {children}
    </StyledSideFlowWrapper>
  )

export default SideFlowWrapper
